import ProfileForm from "./ProfileForm";
import { Profile as ProfileType } from "../profileTypes";

interface Props {
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  profiles: ProfileType[];
  currentProfile: ProfileType;
  setExpandedIds?: any;
  refetch: (
    params?:
      | Omit<
          {
            clientId: string;
          },
          "clientId"
        >
      | undefined
  ) => Promise<void>;
}

const EditProfile = ({
  setIsModalOpen,
  profiles,
  currentProfile,
  refetch,
  setExpandedIds,
}: Props) => {
  const latestProfile = profiles.find((p) => p.id === currentProfile.id) || currentProfile;

  return (
    <ProfileForm
      setIsModalOpen={setIsModalOpen}
      profiles={profiles}
      currentProfile={latestProfile}
      isEditMode={true}
      refetch={refetch}
      setExpandedIds={setExpandedIds}
    />
  );
};

export default EditProfile;
